export default [{ x: 0, y: 0, width: 1, height: 1 }];
